/**
 * Sorry about this GOD class, I did my best with the amount of time I was given
 *
 * .o-tabs
 *
 *   .js-tab-switch(data-id='content-name') //optional
 *   .js-tab-switch(data-id='1')
 *   .js-tab-switch(data-id='2')
 *
 *   o-tabs__content(data-content='content-name') //data-content (optional) needs to match the .js-tab-switch
 *   o-tabs__content(data-content='content-name')
 *
 */
class Tab {
  public elScope: HTMLElement;

  private el: {
    buttons: NodeListOf<HTMLElement>,
    targets: NodeListOf<HTMLElement>,
  }

  private className = {
    active: 'is--active',
  }

  constructor(elScope: HTMLElement) {
    this.elScope = elScope;
    this.cache();
    this.init();
  }

  private cache() {
    this.el = {
      buttons: this.elScope.querySelectorAll('.js-tab-switch[data-id]'),
      targets: this.elScope.querySelectorAll('.o-tabs__content'),
    };
  }

  private init() {
    const { el } = this;

    el.buttons.forEach((elButton) => elButton.addEventListener('click', () => this.onButtonClick(elButton)));
  }

  private onButtonClick(elButtonClicked: HTMLElement) {
    const { el, className } = this;
    const targetId = elButtonClicked.dataset.id;

    const isActive = elButtonClicked.classList.contains(className.active);
    if (isActive) return;

    // Reset all Targets
    el.targets.forEach((elTarget) => {
      elTarget.classList.remove(className.active);
    });

    // Reset all Buttons
    el.buttons.forEach((elButton) => {
      elButton.classList.remove(className.active);
    });

    // Toggle button
    elButtonClicked.classList.add(className.active);

    // Active selected targets by data-content (if is a string)
    if (isNaN(Number(targetId))) {
      const filteredTargets = Array.from(el.targets).filter((elTarget) => {
        return elTarget.dataset.content && elTarget.dataset.content == String(targetId);
      });
      filteredTargets.forEach((elTarget) => elTarget.classList.add(className.active));
      // Active selected target by order
    } else {
      el.targets[Number(targetId) - 1].classList.add(className.active);
    }
  }
}



export default class Tabs {
  init() {
    document.querySelectorAll('.o-tabs').forEach((el) => {
      new Tab(el as HTMLElement);
    });
  }
}
